
import Util from "@/helper/Utility";
export function StandardRegisterModel() {
    this.questionnaire_id = 1513;
    this.display_name = "noname";
    this.user_mid = '';
    this.thai_citizen_id = '';
    this.phone_number = '';
    this.flow_type = null;
    this.is_from_policy_renewal = false;
    this.link_no = 0;


    this.setValueFromCache = function (data) {
        this.display_name = data.display_name || "noname";
        this.user_mid = data.user_mid;
        this.thai_citizen_id = data.thai_citizen_id;
        this.phone_number = data.phone_number;
    };

    this.setMid = function (user_mid) {
        this.user_mid = user_mid;
    };

    this.setDisplayName = function (display_name) {
        this.display_name = display_name;
    };

    this.setThaiCitizenId = function (thai_citizen_id) {
        this.thai_citizen_id = thai_citizen_id;
    };

    this.setPhoneNumber = function (phone_number) {
        this.phone_number = phone_number;
    };

    this.setQuestionnaireId = function(questionnaire_id) {
        this.questionnaire_id = questionnaire_id;
    };

    this.setFlowType = function (flow_type) {
        this.flow_type = flow_type;
    };
    
    this.setFromPolicyRenewal = function(fromPolicyRenewal) {
        this.is_from_policy_renewal = fromPolicyRenewal
    };
    this.setLinkNo = function (link_no) {
        this.link_no = link_no;
    };

    this.getParams = function () {
        let data = {
            "questionnaire_id": this.questionnaire_id,
            "display_name": this.display_name,
            "user_mid": this.user_mid,
            "answers": {
                "thai_citizen_id": this.thai_citizen_id,
                "phone_number": this.phone_number,
            }
        };
        return Util.cleanObjectEmptyStr(data)
    };
    this.getParamsFlowType = function () {
        let data = {
            "questionnaire_id": this.questionnaire_id,
            "user_mid": this.user_mid,
            "link_no": this.link_no,
            "flow_type": this.flow_type,
            "is_from_policy_renewal": this.is_from_policy_renewal,
            "answers": {
                "thai_citizen_id": this.thai_citizen_id,
                "phone_number": this.phone_number,
            }
        };
        return Util.cleanObjectEmptyStr(data)
    }
}
